if (!customElements.get("accordion-wrapper")) {
class Accordion extends HTMLElement {
    constructor() {
      super();
      this.options = this.dataset.options;
      this.items = this.querySelectorAll(".td-accordion__item");
      this.onlyOneActive = true;

      // Check if the elements exist before assigning them
      this.allImages = document.querySelectorAll(".td-goods-img");
      this.initImage = document.querySelector(".td-loaded");
      this.loadedImage = document.querySelector(".td-load");

      // Set flags to determine if image-related elements are present
      this.hasImages = this.allImages.length > 0;
      this.hasInitImage = !!this.initImage;
      this.hasLoadedImage = !!this.loadedImage;
    }

    connectedCallback() {
      this.bindEvents();
    }

    bindEvents() {
      const el = this;
      this.items.forEach(function (item) {
        const toggle = item.querySelector(".td-accordion__toggle");
        if (toggle) {
          toggle.addEventListener("click", (event) => {
            event.preventDefault();
            el.toggle(item.dataset.item);
          });
          if (item.dataset.open) {
            el.toggle(item.dataset.item);
          }
        }

        const toggleNext = item.querySelector(".td-accordion__toggle-next");
        if (toggleNext) {
          toggleNext.addEventListener("click", function (event) {
            event.preventDefault();
            el.toggle(parseInt(item.dataset.item) + 1);
          });
        }
      });
    }

    toggle(currentItem) {
      const el = this;
      this.items.forEach(function (item, i) {
        const content = item.querySelector(".td-accordion__content");
        if (!content) return;
        if (item.dataset.item == currentItem) {
          if (item.classList.contains("is-active")) {
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          }

          // Only execute image-related logic if the relevant elements are present
          if (el.hasInitImage && el.initImage.classList.contains('show')) {
            el.initImage.classList.add('hidden');
            el.initImage.classList.remove('show');
            if (el.hasLoadedImage) {
              el.loadedImage.classList.remove('hidden');
            }
          }
          if (el.hasImages && el.allImages[i]) {
            el.allImages[i].classList.add('td-goods-show-img');
          }

          item.classList.toggle("is-active");
        } else if (el.onlyOneActive) {
          if (el.hasImages && el.allImages[i]) {
            el.allImages[i].classList.remove('td-goods-show-img');
          }
          item.classList.remove("is-active");
          content.style.maxHeight = null;
        }
      });
    }
  }

  customElements.define("accordion-wrapper", Accordion);
}
